// extracted by mini-css-extract-plugin
export var lightMode = "_1n-0";